import React from "react";
import axios from "axios";
import { URL, getAuthorizationHeader } from "../../constans/constants";
import { firmarRRHH, firmarRL } from './RecibosService';
import ProgressBarRecibo from "../mensajeFlash/ProgressBarRecibo";
import { getUsuarioLogueado, getEmpresa } from "../../components/login/SesionService";
import { Form, Modal, Container, Button, InputGroup } from "react-bootstrap";
import { logout } from '../login/SesionService'
import { createGostCanvasAndGetAppareance, loadSignature } from "../tiposDocumento/AparienciaServicios";
import visibility_white from '../../styles/icons/visibility_white.svg';
import visibility_off from '../../styles/icons/visibility_off.svg';

class Pin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      idLote: "",
      keystore: 0,
      formatoFirmaEmpresa: null,
      pin: "",
      respuesta: "",
      severity: "success",
      mostrarPantallaCarga: false,
      redirect: "",
      signatureEmpresa: {},
      datosUsuarios: {},
      datosEmpresa: {},
      tipoFirma: "",
      openPantallaCarga: false,
      validated: false,
      recibosFirmados: {},
      cantidadRecibos: 0,
      cantidadFirmadas: 0,
      respuestaRecibosFirmados: {},
      isLoaded: false,
      mostrarPassword: false,
      errors: {
        pin: null
      }
    };
    this.dialogRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.cargarDatosIniciales();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.cargarDatosIniciales();
    }

    if (!prevState.isLoaded && this.state.isLoaded) {
      this.abrirModal();
    }

    if (!this.props.isOpen && prevProps.isOpen) {
      this.cerrarModalConAnimacion();
    }
  }


  abrirModal = () => {
    if (this.dialogRef.current && !this.dialogRef.current.open) {
      this.dialogRef.current.showModal();
    }
  }

  cerrarModal = () => {
    if (this.dialogRef.current && this.dialogRef.current.open) {
      this.dialogRef.current.close();
    }
  }

  cerrarModalConAnimacion = () => {
    if (this.dialogRef.current && this.dialogRef.current.open) {
      this.dialogRef.current.style.scale = '0';
      setTimeout(() => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
          this.dialogRef.current.close();
        }
      }, 300);
    }
  }

  manejarCancelar = () => {
    this.cerrarModalConAnimacion();
    setTimeout(() => {
      this.props.handleClose(false, null, this.state.tipoFirma);
    }, 300);
  }

  handleClickCancelar = () => {
    this.manejarCancelar();
  }

  cargarDatosIniciales = () => {
    var token = {
      token: localStorage.getItem("tokenIscert"),
      psa: localStorage.getItem("codigoClienteFirma")
    }
    axios
      .post(URL + "payrolls/iscert/keystore", token, getAuthorizationHeader())
      .then((res) => {
        if (res.data.error == false) {
          this.setState({ keystore: res.data.datos.keystores[0].id, isLoaded: true });
        } else {
          this.setState({ isLoaded: false });
          this.manejarCancelar(); // Cerramos el modal con animación
          this.props.handleClose(false, res.data, this.state.tipoFirma);
        }
      }, error => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      })
    axios
      .get(
        URL + "lote/getEmpresaSignFormat/" + this.props.idLote,
        getAuthorizationHeader()
      )
      .then((res) => {
        if (res.data.error == false) {
          this.setState({ formatoFirmaEmpresa: res.data.datos });
        } else {
          this.props.handleClose(false, res.data, this.state.tipoFirma);
        }
      }, error => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      });
    getUsuarioLogueado().then((response) => {
      this.setState({ datosUsuarios: response });
    });
    getEmpresa().then((response) => {
      this.setState({ datosEmpresa: response })
    });
    if (this.props.estado == 'nuevo') {
      axios
        .get(
          URL + "lote/recibosFirmados/RRHH/" + this.props.idLote,
          getAuthorizationHeader()
        )
        .then((res) => {
          if (res.data.error == false) {
            this.setState({ recibosFirmados: res.data.datos });
          } else {
            this.props.handleClose(false, res.data, this.state.tipoFirma);
          }
        }, error => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        });
    }
    else if (this.props.estado == 'firmado') {
      axios
        .get(
          URL + "lote/recibosFirmados/RL/" + this.props.idLote,
          getAuthorizationHeader()
        )
        .then((res) => {
          if (res.data.error == false) {
            this.setState({ recibosFirmados: res.data.datos });
          } else {
            this.props.handleClose(false, res.data, this.state.tipoFirma);
          }
        }, error => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        });
    }
  }

  handleClose = (data) => {
    if (data.error) {
      this.cerrarModal()
      this.props.handleClose(false, data, this.state.tipoFirma);
      return;
    }
    var cantidadRecibosFirmados = data.datos.filter(item => item.firmado === true).length;
    if (cantidadRecibosFirmados == this.state.recibosFirmados.length) {
      this.props.handleClose(false, data, this.state.tipoFirma);
    }
    this.actualizarDatosRecibosFirmados(data.datos)
  };

  actualizarDatosRecibosFirmados = (data) => {
    var cantidadRecibosFirmados = data.filter(item => item.firmado === true).length;
    this.setState({ cantidadRecibos: data.length, cantidadFirmadas: cantidadRecibosFirmados })
  }

  handleFirmasPDF = (value) => {
    this.setState({ tipoFirma: value })
  };

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  validarCamposFormulario = () => {
    let errors = {}
    let isValid = false
    if (this.state.pin === null || this.state.pin.trim() === "") {
      errors = { pin: "Debe ingresar un Pin valido" }
      return { isValid, errors }
    } else
      isValid = true

    return { isValid, errors }
  }

  handlePinSubmit = async (event) => {
    event.preventDefault();
    if (this.state.openPantallaCarga) return;
    const { isValid, errors } = this.validarCamposFormulario()
    if (!isValid) {
      this.setState({ errors: errors })
    } else {
      this.setState({ openPantallaCarga: true });
      var responseError = {};
      if (this.props.formatoDocumento == "PDF") {
        var formatoEmpresa = await loadSignature(this.state.formatoFirmaEmpresa, this.state.datosUsuarios, this.state.datosEmpresa, true);
        var apariencia = null;
        try {
          for (const item of this.state.recibosFirmados) {
            var json = {
              idLote: this.props.idLote,
              idRecibo: item.idRecibo,
              keystore: this.state.keystore,
              appearance: apariencia,
              formatoFirmaEmpresa: this.state.formatoFirmaEmpresa,
              pin: this.state.pin
            };

            if (formatoEmpresa.appearance) {
              json = await createGostCanvasAndGetAppareance(formatoEmpresa, json, this.props.estado, this.handleClose, this.handleFirmasPDF);
              const response = await this.firmar(json);
              if (response.data.error) {
                responseError = response
                throw new Error(responseError);
              }
              this.handleClose(response.data);
            }
          }
        } catch (error) {
          this.props.handleClose(false, responseError.data, this.state.tipoFirma);
        }
        /* this.setState({ openPantallaCarga: false }); */
      } else {
        try {
          for (const item of this.state.recibosFirmados) {
            const json = {
              idLote: this.props.idLote,
              idRecibo: item.idRecibo,
              keystore: this.state.keystore,
              formatoFirmaEmpresa: this.state.formatoFirmaEmpresa,
              pin: this.state.pin
            };
            if (this.props.estado == 'nuevo') {
              const response = await firmarRRHH(json)
              if (response.data.error) {
                responseError = response
                throw new Error(responseError);
              }
              this.handleFirmasPDF('RRHH')
              this.handleClose(response.data);
            } else if (this.props.estado == 'firmado') {
              const response = await firmarRL(json);
              if (response.data.error) {
                responseError = response
                throw new Error(responseError);
              }
              this.handleFirmasPDF('RL');
              this.handleClose(response.data);
            }
          }
        } catch (error) {
          this.props.handleClose(false, responseError.data, this.state.tipoFirma);
        }
      }
    }
  };


  firmar = async (json) => {
    if (this.props.estado == 'nuevo') {
      const response = await firmarRRHH(json)
      this.handleFirmasPDF('RRHH')
      return response;
    } else if (this.props.estado == 'firmado') {
      firmarRL(json).then((response) => {
        this.handleFirmasPDF('RL')
        return response;
      });
    }
  }

  setMostrarPassword = () => {
    this.setState(prevState => ({ mostrarPassword: !prevState.mostrarPassword }))
  }

  handleInput = (e) => {
    var name = e.target.name;
    var val = e.target.value;
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: null
      },
      [name]: val,
    }))
  };

  render() {
    const { isOpen } = this.props;

    if (!isOpen || !this.state.isLoaded) return null;

    return (
      <div className="component-modal">
        <ProgressBarRecibo
          cantidadProcesada={this.state.cantidadFirmadas}
          cantidadTotal={this.state.cantidadRecibos}
          isOpen={this.state.openPantallaCarga}
          onClose={() => this.setState({ openPantallaCarga: false })}
        />

        <dialog
          className="modal"
          id="modal-pin"
          ref={this.dialogRef}
          onClose={this.manejarCancelar}
        >
          <div className="modal-content">

            <div className="modal-body">
              <h3 className="title">Ingresar PIN de firma</h3>

              {/* Sección de datos del lote - mantenida pero oculta visualmente */}
              <div className="datosLotes" /* style={{ display: 'none' }} */>
                <p className="form-date"><strong>Confirmar datos:</strong></p>
                <div className="lote-date">
                  Lote: {this.props.numeroLote} | fecha importación: {this.props.fechaImportacionLote}
                </div>
                <div className="lote-row">
                  <p className="lote-text">
                    <strong>Descripción:</strong> {this.props.descripcionLote}
                  </p>
                  <p className="lote-text">
                    <strong>Cantidad:</strong> {this.props.cantidadDocumentoLote}.
                  </p>
                </div>
              </div>

              <form className="form" noValidate validated={this.state.validated} onSubmit={this.handlePinSubmit}>
                {/* Input con el nuevo diseño */}
<div className="form-group" style={{ position: 'relative' }}>
  <input
    id="pin"
    type={this.state.mostrarPassword ? "text" : "password"}
    name="pin"
    className="form-input"
    placeholder=""
    onChange={this.handleInput}
    value={this.state.pin}
    required
  />
  <label htmlFor="pin" className="form-label">Ingresar tu PIN</label>
  <button
    type="button"
    onClick={this.setMostrarPassword}
    className="btn-eye"
    style={{
      position: 'absolute',
      right: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'none',
      border: 'none',
      cursor: 'pointer'
    }}
  >
<span className="material-symbols-outlined"> visibility </span>
  </button>
</div>


                {/* Mensajes de error mantenidos */}
                {this.state.errors.pin && (
                  <div className="error-message">
                    <small style={{ color: "red" }}>{this.state.errors.pin}</small>
                  </div>
                )}

                {this.state.errorPin && (
                  <div className="error-message">
                    <small style={{ color: "red" }}>*Ocurrió un error mientras se recuperaban datos del keystore</small>
                  </div>
                )}

                <div className="modal-footer">
                  <button
                    className="btn-medium btn-base-outline"
                    type="button"
                    onClick={this.handleClickCancelar}
                  >
                    Cancelar
                  </button>
                  <button
                    className="btn-medium btn-primary"
                    type="submit"
                    disabled={!this.state.isLoaded || this.state.openPantallaCarga}
                  >
                    Enviar
                  </button>
                </div>
              </form>

            </div>

          </div>
        </dialog>

      </div>
    );
  }
}

export default Pin;